import { PartyPopper, Home, Cake, Music2, Disc3, UtensilsCrossed, GraduationCap, Sparkles, Heart, Star, Coffee, Users } from "lucide-react";

const ICONS = {
  Sparkles,
  PartyPopper,
  Home,
  Cake,
  Music2,
  Disc3,
  UtensilsCrossed,
  GraduationCap,
  Heart,
  Star,
  Coffee,
  Users,
};

export default function CategoryChips({ active, onChange, categories, theme = "simple" }) {
  return (
    <div className="category-chip-rail absolute z-[480] hide-scrollbar">
      <div className="category-chip-list">
        {categories.map((cat) => {
          const Icon = ICONS[cat.icon] || Sparkles;
          const isActive = active === cat.id;
          return (
            <button
              key={cat.id}
              data-testid={`category-chip-${cat.id.replace(/\s+/g, "-").toLowerCase()}`}
              onClick={() => onChange(cat.id)}
              className={[
                `category-chip category-chip-${theme}`,
                "flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap border",
                isActive
                  ? "category-chip-active shadow-md"
                  : "glass text-gray-800 border-white/60 hover:bg-white",
              ].join(" ")}
            >
              <Icon className="w-3.5 h-3.5" />
              {cat.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
